<template>
  <v-app>
    <navigation-bar v-if="showNav"></navigation-bar>
    <navigation-bar-mobile v-if="showNav"></navigation-bar-mobile>

    <newsletter></newsletter>
    <terms></terms>
    <video-player></video-player>
    <new-portal v-if="$store.getters['isLoggedIn']"></new-portal>
    <upgrade-dialog v-if="$store.getters['isLoggedIn']"></upgrade-dialog>
    <downgrade-dialog v-if="$store.getters['isLoggedIn']"></downgrade-dialog>
    <limit-reached v-if="$store.getters['isLoggedIn']"></limit-reached>
    <trial-ended v-if="$store.getters['isLoggedIn']"></trial-ended>

    <notifications-dialog></notifications-dialog>
    <applicant-success></applicant-success>
    <v-content>
      <transition>
        <router-view></router-view>
      </transition>
    </v-content>
    <my-footer v-if="showFooter"></my-footer>
  </v-app>
</template>

<script>
import terms from "@/components/global/terms";
import footer from "@/components/global/footer";
import newsletter from "@/components/global/newsletter";
import navigationBar from "@/components/global/navigation";
import navigationBarMobile from "@/components/global/navigation_mobile";
import videoPlayer from "@/components/global/video_player";
import eventBus from "@/event-bus";

import notificationsDialog from "@/components/global/notifications";

//User dialogs
import newPortal from "@/components/user/dialogs/new_portal";
import upgradeDialog from "@/components/user/dialogs/upgrade";
import downgradeDialog from "@/components/user/dialogs/downgrade";
import limitReached from "@/components/user/dialogs/limit_reached";
import trialEnded from "@/components/user/dialogs/trial_ended";

//Applicant dialogs
import applicantSuccess from "@/components/portal/applicant/success_dialog";

export default {
  name: "App",

  components: {
    myFooter: footer,
    terms,
    newsletter,
    videoPlayer,
    navigationBar,
    navigationBarMobile,
    newPortal,
    upgradeDialog,
    downgradeDialog,
    limitReached,
    trialEnded,
    notificationsDialog,
    applicantSuccess,
  },

  data: () => ({
    //
  }),
  created() {
    this.handleHash();
  },
  watch: {
    "$route.hash": function () {
      this.handleHash();
    },
  },
  computed: {
    showFooter() {
      if (
        ["Viewer", "Applicant", "ApplicantView", "LibraryView"].includes(
          this.$route.name
        )
      ) {
        return false;
      } else {
        return true;
      }
    },
    showNav() {
      if (
        [
          "Login",
          "Register",
          "Viewer",
          "Applicant",
          "ApplicantView",
          "LibraryView",
        ].includes(this.$route.name)
      ) {
        return false;
      }
      return true;
    },
  },
  methods: {
    handleHash() {
      if (this.$route.hash) {
        if (this.$route.hash.includes("billing")) {
          this.$store.dispatch("loadBilling");
        }
      }
    },
    showTerms() {
      eventBus.$emit("show-terms");
    },
  },
};
</script>

<style lang="scss" >
.text-small {
  font-size: 14px;
}

.v-tabs-slider-wrapper {
  z-index: 2 !important;
}
.country-selector__list {
  z-index: 5000 !important;
  -webkit-overflow-scrolling: auto !important;
}
.vue-recycle-scroller__item-wrapper {
  z-index: 5001 !important;
}
.vue-recycle-scroller__item-view {
  z-index: 5002 !important;
}

@font-face {
  font-family: "Arial Rounded MT Bold";
  src: url("/fonts/ArialRoundedMTBold.ttf"),
    url("/fonts/ArialRoundedMTBold.eot?"), url("/fonts/ArialRoundedMTBold.svg");
}

.hover-tile {
  -webkit-transition: 0.2s ease;
  -moz-transition: 0.2s ease;
  -o-transition: 0.2s ease;
  transition: 0.2s ease;
}

.hover-tile:hover {
  transform: translateY(-5px);
  -webkit-box-shadow: 0px 10px 9px -5px rgba(0, 0, 0, 0.555);
  -moz-box-shadow: 0px 10px 9px -5px rgba(0, 0, 0, 0.555);
  box-shadow: 0px 10px 9px -5px rgba(0, 0, 0, 0.555);
}

.white-gradient {
  background: rgb(255, 255, 255);
  background: radial-gradient(
    circle,
    rgba(255, 255, 255, 1) 50%,
    rgba(174, 179, 178, 1) 100%
  );
}
.text-shadow {
  text-shadow: 2px 2px 6px rgba(0, 0, 0, 0.5);
}
.monster {
  font-family: "Montserrat", sans-serif;
}
.page-heading {
  font-family: "Montserrat", sans-serif;
}

.raleway {
  font-family: "Raleway", sans-serif;
}

.nolink {
  text-decoration: none;
}
.draggable {
  cursor: move !important;
}
.clicky {
  cursor: pointer;
}
.v-application p {
  margin-bottom: 0px !important;
}
.ql-align-center {
  text-align: center;
}
.ql-align-right {
  text-align: right;
}
.ql-align-left {
  text-align: left;
}
.gradient-text-clip {
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

#asdasdasddsaasd {
  @media only screen and (max-width: 600px) {
    /* xs */
  }
  @media only screen and (max-width: 960px) and (min-width: 600px) {
    /* sm */
  }
  @media only screen and (max-width: 1264px) and (min-width: 960px) {
    /* md */
  }
  @media only screen and (max-width: 1904px) and (min-width: 1264px) {
    /* lg */
  }
  @media only screen and (min-width: 1904px) {
    /* xl */
  }
}
</style>